/** Does nothing */
export default function noop() {
    // return undefined;
}
